// Length

const formatLength = inM => {
  const inKm = inM*0.001;
  return inM < 2000 ? Math.round(inM) : (inKm > 1000 ? inKm : inKm);
}

const formatLengthUnit = inM => {
  return inM < 2000 ? 'm' : 'km';
}

const formatLengthExtra = inM => {
  return inM > 2000 ? Math.round(inM).toLocaleString()+' m' : null;
}

const toMeters = inM => ({
  value:formatLength(inM),
  unit:formatLengthUnit(inM),
  extra:formatLengthExtra(inM)
});

// Area

const formatValue = inSqM => {
  const inAcres = inSqM*0.00024711;
  return inSqM < 4000 ? Math.round(inSqM) : (inAcres > 1000 ? inAcres.toFixed(0) : inAcres);
}

const formatUnit = inSqM => {
  return inSqM < 4000 ? 'm²' : 'acre';
}

const formatExtra = inSqM => {
  return inSqM > 4000 ? Math.round(inSqM).toLocaleString()+' m²' : null;
}

const toAcres = inSqM => ({
  value:formatValue(inSqM),
  unit:formatUnit(inSqM),
  extra:formatExtra(inSqM)
});

// Time

const formatTime = date => {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  return hours + ampm;
}

const formatDate = date => {
  let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[date.getMonth()] + " " + date.getDate() + ",  " + formatTime(date);
}

export {toMeters, toAcres, formatDate, formatTime};
